import React from "react";
import { useNavigate } from "react-router-dom";
import AdapterEditor from "../../components/adapters/AdapterEditor";

export default function AdaptersCreate() {
  const navigate = useNavigate();

  return (
    <AdapterEditor
      mode="page"
      formAction="create"
      onSaveSuccess={() => navigate("/edge-management/adapters")}
      onCancel={() => navigate("/edge-management/adapters")}
    />
  );
}
